import { render, staticRenderFns } from "./customer_confirm.vue?vue&type=template&id=3aa672d1&scoped=true&"
import script from "./customer_confirm.vue?vue&type=script&lang=js&"
export * from "./customer_confirm.vue?vue&type=script&lang=js&"
import style0 from "./customer_confirm.vue?vue&type=style&index=0&id=3aa672d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa672d1",
  null
  
)

export default component.exports